<template>
  <div class="flex flex-row w-full  border-grey-light mb-4">
    <div class="flex justify-between flex-wrap">
      <div class="flex flex-row max-w-full flex-wrap justify-end bg-grey-">
        <template v-for="(side, index) in sideLabels">
          <div
            :key="index"
            class="w-1/2 flex flex-row justify-start"
            :class="{ 'pb-2': index < 2 }"
          >
            <div
              class="mr-2 ml-0"
              :class="{
                'text-pink': isSelected(side),
                'text-white': !isSelected(side),
                'mt-1': index < 2,
                'mb-1 flex items-end': index > 1
              }"
              @click="select(side);"
            >
              <component
                :is="sides[side]"
                v-if="!(index % 2)"
                class=" h-4 w-4 fill-current"
              ></component>
            </div>
            <gd-dropdown
              :value="values[side]"
              dark
              size="small"
              :options="options"
              @change="setSide($event, side);"
            ></gd-dropdown>
            <div
              class="ml-2 mr-0"
              :class="{
                'text-pink': isSelected(side),
                'text-white': !isSelected(side),
                'mt-1': index < 2,
                'mb-1 flex items-end': index > 1
              }"
              @click="select(side);"
            >
              <component
                :is="sides[side]"
                v-if="index % 2"
                class=" h-4 w-4 fill-current"
              ></component>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import GdDropdown from './Dropdown';
import TopRightCorner from '../assets/top-right-corner.svg';
import TopLeftCorner from '../assets/top-left-corner.svg';
import BottomRightCorner from '../assets/bottom-right-corner.svg';
import BottomLeftCorner from '../assets/bottom-left-corner.svg';

export default {
  name: 'SidesMultiDropdownPanel',
  components: { GdDropdown },
  props: ['values', 'options'],
  data() {
    return {
      sides: {
        tl: TopLeftCorner,
        tr: TopRightCorner,
        bl: BottomLeftCorner,
        br: BottomRightCorner
      },
      selected: ['tl', 'tr', 'bl', 'br']
    };
  },
  computed: {
    sideLabels() {
      return Object.keys(this.sides);
    }
  },
  methods: {
    select(side) {
      if (this.selected.includes(side)) {
        this.selected = this.selected.filter(selected => selected !== side);
      } else {
        this.selected.push(side);
      }
    },
    setSide(value, side) {
      if (!this.selected.includes(side)) {
        this.$emit('set-style', { side, value });
      } else {
        this.selected.forEach(selected => {
          this.$emit('set-style', { side: selected, value });
        });
      }
    },
    isSelected(side) {
      return this.selected.includes(side);
    },
    getGroupPosition(side) {
      const sides = Object.keys(this.sides);
      if (side === sides[0]) return 'left';
      if (side === sides[sides.length - 1]) return 'right';
      return 'middle';
    }
  }
};
</script>
